import React, { useMemo, useState } from "react";
import ExcelImportPage from "./ExcelImportPage";

const ImportCottageCustomers = () => {
  const [createMissingCustomers, setCreateMissingCustomers] = useState(true);

  const extraFields = useMemo(
    () => [
      {
        type: "checkbox",
        name: "create_missing_customers",
        value: createMissingCustomers ? "true" : "false",
        checked: createMissingCustomers,
        onChange: setCreateMissingCustomers,
        label: "اگر مشتری در سیستم وجود نداشت، مشتری جدید ساخته شود.",
      },
    ],
    [createMissingCustomers]
  );

  return (
    <ExcelImportPage
      title="اختصاص مشتری به اظهارنامه از اکسل"
      endpoint="/import-cottage-customers/"
      fileFieldName="file"
      description="فایل اکسل شامل شماره کوتاژ و نام مشتری را بارگذاری کنید. نام ها قبل از تطبیق نرمال سازی می شوند."
      requiredColumns={["شماره کوتاژ", "مشتری"]}
      extraFields={extraFields}
    />
  );
};

export default ImportCottageCustomers;
